import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../Note/Notetab';

import { useGetNotesBySourceQuery } from 'store/services/noteApi';
import { useSendOutCollectionDetailContext } from "contexts/SendOutCollectionDetailContext";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import SendOutCollectionShipmentList from "./SendOutCollectionShipmentList";

const SendOutCollectionDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'note';

  const { sendOutCollectionDetail } = useSendOutCollectionDetailContext();

  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: 'SendOutCollection',
      sourceRef: sendOutCollectionDetail?._id,
    },
    { skip: !sendOutCollectionDetail?._id }
  );
  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'SendOutCollection', sourceRef: sendOutCollectionDetail?._id, }, { skip: !sendOutCollectionDetail?._id }
  );

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0,
    },

    { label: "Shipment", value: "shipment", badgeCount: sendOutCollectionDetail?.shipmentId?.length },

    { label: "Document", value: "document", badgeCount: documents?.totalItems },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {sendOutCollectionDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="SendOutCollection" sourceRef={sendOutCollectionDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="SendOutCollection" sourceRef={sendOutCollectionDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
            <SendOutCollectionShipmentList />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default SendOutCollectionDetailTab;